'use strict';

const config = require('json!../config.json');

class Config {
	/*@ngInject*/
	constructor() {
		_.extend(this, config);
	}
}

export default Config;


// WEBPACK FOOTER //
// ./client/app/common/config.js